import { Mode, ModeTransitionProps } from "@/modes/mode";
import { changeMode } from "@/store/mode-slice";
import { selectSheetCadAlignmentReference } from "@/store/modes/sheet-cad-alignment-mode-selectors";
import {
  resetSheetCadAlignment,
  setSheetCadAlignmentStep,
  setSheetElevation,
  SheetCadAlignmentStep,
  SheetCadAlignReference,
} from "@/store/modes/sheet-cad-alignment-mode-slice";
import { useAppDispatch, useAppSelector } from "@/store/store-hooks";
import { selectIElementWorldPosition } from "@faro-lotv/app-component-toolbox";
import { useEffect } from "react";
import { useSheetSelectedForAlignment } from "../mode-data-context";
import { SheetCadAlignmentModeOverlay } from "./sheet-cad-alignment-mode-overlay";
import { SheetCadAlignmentModeScene } from "./sheet-cad-alignment-mode-scene";

export const sheetCadAlignmentMode: Mode = {
  name: "sheetCadAlignment",
  ModeScene: SheetCadAlignmentModeScene,
  ModeOverlay: SheetCadAlignmentModeOverlay,
  ModeTransition: SheetCadAlignmentModeTransition,
  hasCustomCanvasStyle: true,
  exclusive: {
    title: (state) => {
      const alignmentReference = selectSheetCadAlignmentReference(state);
      return alignmentReference === SheetCadAlignReference.bimModel
        ? "Align sheet to 3D model"
        : "Align 3D model to sheet";
    },
    onBack({ dispatch }) {
      // if user canceled alignment by pressing back we need to reset
      // temporary data to prevent reusing it in the next session of alignment
      dispatch(resetSheetCadAlignment());

      dispatch(changeMode("overview"));
      return Promise.resolve();
    },
  },
};

function SheetCadAlignmentModeTransition({
  onCompleted,
}: ModeTransitionProps): null {
  const sheet = useSheetSelectedForAlignment("sheetAndCad");
  const sheetPosition = useAppSelector(selectIElementWorldPosition(sheet.id));

  const dispatch = useAppDispatch();

  useEffect(() => {
    // make sure to start with the first step (set elevations)
    dispatch(setSheetCadAlignmentStep(SheetCadAlignmentStep.setElevation));

    // use sheet position as initial elevation
    dispatch(setSheetElevation(sheetPosition[1]));

    onCompleted();
  }, [dispatch, onCompleted, sheetPosition]);

  return null;
}
